export default "__VITE_ASSET__Bo3f3EGP__"